/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable object-curly-newline */
/* eslint-disable no-void */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
/* eslint-disable import/no-cycle */
/* eslint-disable max-len */

import {
    CAREER_STATUS_COMPLETED,
    CAREER_STATUS_NOT_COMPLETED,
    CAREER_STATUS_NOT_COMPLETED_CANCELED,
    CAREER_STATUS_NOT_COMPLETED_DISABLED,
    CAREER_TYPE_CLASSROOM,
    CAREER_TYPE_ELEARNING,
    CareerStatuses,
} from "../../Constants";
import { currentDate, DateFormats, diffDay, parseJSDate, separateStartAndEndDate } from "../datetime";

interface Career {
    careerId: string;
    careerTypeId: string;
    classId: string;
    careerTitle?: string;
    jissiKikan?: string;
    status?: string;
    classroom?: string;
    progress?: string;
}

export interface AlertDaysReturn {
    alertView: boolean;
    remainingDays?: number;
}

const ALERT_VIEW_DAYS = 7;

const isTargetCareerTypeId = (careerTypeId: string | number, target: string) => String(careerTypeId) === target;
export const isELearning = (careerTypeId: string | number) => isTargetCareerTypeId(careerTypeId, CAREER_TYPE_ELEARNING);
export const isGroupTraining = (careerTypeId: string | number) => isTargetCareerTypeId(careerTypeId, CAREER_TYPE_CLASSROOM);

export const alertDays = (career: Career) => {
    if (!isELearning(career.careerTypeId)) return { alertView: false };
    const { endDate } = separateStartAndEndDate(career.jissiKikan);
    if (!endDate) {
        return { alertView: false, remainingDays: -1 };
    }
    const targetDate = parseJSDate(separateStartAndEndDate(career.jissiKikan).endDate, DateFormats.YYYYMMDDHHMM);
    const today = currentDate();
    const diffDays = diffDay(targetDate!, today);
    const deadlineAlertView = diffDays >= 0 && diffDays <= ALERT_VIEW_DAYS && !Number.isNaN(diffDays);
    return { alertView: deadlineAlertView, remainingDays: diffDays };
};

// ある講座のステータスが、特定のステータスの一覧に含まれるか確認する
export const statusMatches = (status: string, targets: string[]) => targets.some((target) => target === status);

export const LATEST_SEQ_CAREER_HISTORY = "0";
interface OnGoingHistory {}
interface ResultHistory {
    status: string;
    seq: string;
}

/**
 * 講座(研修)の最新の受講履歴を取得する。
 *
 * @param onGoing 実施中の履歴(同じ研修の受講履歴のみにフィルタ済みであること)
 * @param results 実績の履歴(同じ研修の受講履歴のみにフィルタ済みであること)
 * @returns onGoing、resultsから特定した最新履歴。<br/>
 *          受講履歴が無い場合はundefined。
 */
export const findLatestHistory = <O extends OnGoingHistory, R extends ResultHistory>(onGoing: O[], results: R[]): O | R | undefined => {
    // 実施中の履歴があれば、その履歴を最新の履歴とする: 実施中の履歴は最大1件
    if ((onGoing || []).length) return onGoing[0];

    // 実績も履歴がなければ、履歴なしとして扱う
    if (!(results || []).length) return undefined;

    // ステータスが[修了・未修了]かつ[SEQ=0]の実績があれば最新の履歴とする
    const completed = results.find(
        (_career) =>
            statusMatches(_career.status, [
                CareerStatuses[CAREER_STATUS_COMPLETED], // 修了
                CareerStatuses[CAREER_STATUS_NOT_COMPLETED], // 未修了
            ]) && _career.seq === LATEST_SEQ_CAREER_HISTORY
    );
    if (completed) return completed;

    // ステータスが[未修了(キャンセル)・未修了(受講不可)]の実績の件数で処理分け
    const notCompleted =
        results.filter(
            (_career) =>
                statusMatches(_career.status, [
                    CareerStatuses[CAREER_STATUS_NOT_COMPLETED_CANCELED], // 未修了(キャンセル)
                    CareerStatuses[CAREER_STATUS_NOT_COMPLETED_DISABLED], // 未修了(受講不可)
                ]) && _career.seq === LATEST_SEQ_CAREER_HISTORY
        ) || [];

    // ステータスが未修了(キャンセル)と未修了(受講不可)の実績が存在しない場合、SEQが最大のデータを最新の履歴とする
    if (!notCompleted.length) return results.reduce((a, b) => (Number(a.seq) >= Number(b.seq) ? a : b));

    // SEQが0の実績が1つの場合は最新の履歴とする
    if (notCompleted.length === 1) return notCompleted[0];

    // SEQが0の実績が2つ以上存在する場合は、未修了(キャンセル)を最新の履歴とする
    return notCompleted.find((_career) => statusMatches(_career.status, [CareerStatuses[CAREER_STATUS_NOT_COMPLETED_CANCELED]]));
};
